import { checkForVaiControllerTransactionError } from 'errors';
import type { TransactionReceipt } from 'web3-core';

import { VaiController, UmiVault } from 'types/contracts';

export interface IsetOutRoiInput {
  umiControllerContract: UmiVault;
  fromAccountAddress: string;
  amountWei: string;
}

export type IsetOutRoiOutput = TransactionReceipt;

const setOutRoi = async ({
                          umiControllerContract,
  fromAccountAddress,
  amountWei,
}: IsetOutRoiInput): Promise<IsetOutRoiOutput> => {
  const resp = await umiControllerContract.methods
    .setOutRoi(amountWei)
    .send({ from: fromAccountAddress });
  return checkForVaiControllerTransactionError(resp);
};

export default setOutRoi;
